import {v4} from 'uuid';
import FirestoreManager from '../api/firebaseManager';
import createDataContext from './createDataContext';

const bridgeReducer = (state, action) => {
  const {connection, id, connections, ids, uid, user_id} = action.payload;
  switch (action.type) {
    case 'default':
      return {...state, ...action.payload};
    case 'createConnection':
      return {
        ...state,
        connection_ids: [id, ...state.connection_ids],
        connections: {...state.connections, [id]: connection},
      };
    case 'editConnection':
      return {
        ...state,
        connections: {
          ...state.connections,
          [id]: {...state.connections[id], ...connection},
        },
      };
    case 'getUserConnections':
      return {
        ...state,
        user_connections: {...state.user_connections, [uid]: ids},
        connections: {...state.connections, ...connections},
      };
    case 'removeConnection':
      const removed_connections = [...state.connection_ids].filter(
        con_id => con_id !== id,
      );
      return {...state, connection_ids: removed_connections};
    case 'removeUser':
      const filtered_connections = {...state.user_connections, [user_id]: []};
      return {
        ...state,
        user_connections: filtered_connections,
      };
    case 'error':
      return {...state, error: action.payload};
    default:
      return state;
  }
};

const fetchInitialBridge = dispatch => async uid => {
  try {
    const connection_list = await FirestoreManager.getBridgeItems(uid);

    const connections = {};
    const connection_ids = connection_list.map(account => {
      const {id} = account;
      connections[id] = account;
      return id;
    });

    const payload = {
      connection_ids,
      connections,
      error: null,
    };
    dispatch({type: 'default', payload});
  } catch (err) {
    dispatch({type: 'error', payload: 'Something went wrong'});
  }
};

const createConnection = dispatch => async connection => {
  try {
    const id = v4();
    await FirestoreManager.setBridgeItem(id, {...connection, id});

    const payload = {
      id,
      connection: {...connection, id},
      error: null,
    };
    dispatch({type: 'createConnection', payload});
    return {success: true, error: null};
  } catch (err) {
    console.log(err);
    dispatch({type: 'error', payload: 'Something went wrong'});
    return {success: false, error: err};
  }
};

const editConnection = dispatch => async connection => {
  try {
    const {id} = connection;
    await FirestoreManager.setBridgeItem(id, connection);

    const payload = {
      id,
      connection: {...connection, id},
      error: null,
    };
    dispatch({type: 'editConnection', payload});
    return {success: true, error: null};
  } catch (err) {
    console.log(err);
    dispatch({type: 'error', payload: 'Something went wrong'});
    return {success: false, error: err};
  }
};

const getUserConnections = dispatch => async uid => {
  try {
    const connection_list = await FirestoreManager.getBridgeItems(uid);

    const connections = {};
    const ids = connection_list.map(account => {
      const {id} = account;
      connections[id] = account;
      return id;
    });

    const payload = {ids, connections, uid};
    dispatch({type: 'getUserConnections', payload});
  } catch (err) {
    dispatch({type: 'error', payload: 'Something went wrong'});
  }
};

const removeConnection = dispatch => async connection => {
  try {
    const {id, custodian_mappings} = connection;
    await FirestoreManager.removeBridgeItem(id);
    await Promise.all(
      custodian_mappings.map(async custodian_mapping => {
        await FirestoreManager.deleteBridgeCustodian({
          id: custodian_mapping.id,
        });
      }),
    );
    const payload = {id};
    dispatch({type: 'removeConnection', payload});
    return {success: true, error: null};
  } catch (err) {
    dispatch({type: 'error', payload: 'Something went wrong'});
  }
};

const removeUserConnections = dispatch => async (user_id, connections) => {
  try {
    await Promise.all(
      connections.map(async connection => {
        const {id, custodian_mappings} = connection;
        await FirestoreManager.removeBridgeItem(id);
        await Promise.all(
          custodian_mappings.map(async custodian_mapping => {
            await FirestoreManager.deleteBridgeCustodian({
              id: custodian_mapping.id,
            });
          }),
        );
      }),
    );
    const payload = {user_id};
    dispatch({type: 'removeUser', payload});
  } catch (err) {
    dispatch({type: 'error', payload: 'Something went wrong'});
  }
};

const defaultValues = {
  connection_ids: [],
  connections: {},
  user_connections: [],
  error: null,
};

export const {Provider, Context} = createDataContext(
  bridgeReducer,
  {
    fetchInitialBridge,
    createConnection,
    editConnection,
    getUserConnections,
    removeConnection,
    removeUserConnections,
  },
  defaultValues,
);
